import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    gtag(method: string, ...args: any[]): void
  }
}

/*

  From docs:

  window.gtag('event', ...)

  Usage:

  gtag.event(...)

 */

const windowEntity = 'gtag'

const methods = {
  event: true,
}

interface IGTag {
  event(name: 'page_view', data: {
    ecomm_prodid: number | number[],
    ecomm_pagetype?: 'home' | 'searchresults' | 'category' | 'product' | 'cart' | 'purchase' | 'other',
    ecomm_totalvalue?: number,
    ecomm_category?: string,
  }): void
}

const gtag = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.gtag),
  eventHandler: (methodName, ...args) => {
    window.gtag(methodName, ...args)
  },
}) as unknown as IGTag


export default gtag

export {
  windowEntity,
  methods,
}
